import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Select from "react-dropdown-select";
import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import Modal from "react-modal";
import PerfectScrollbar from "react-perfect-scrollbar";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import RadioButtonUncheckedOutlinedIcon from "@material-ui/icons/RadioButtonUncheckedOutlined";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import {getUserDetails, getUserInformation} from "../store/userManagement"
import {
  getInsContacts,
  getInsContactsInformation,
  getIsUpdating,
  getUpdateErrors,
  addInsContact,
  deleteInsContact,
  toggleInsurerCodesModal,
  getInsCodeStatus,
  getInsurerCodesSelector,
  getInsCodes,
  updateInsContactDefault,
  toggleInsContactsModal,
  getInsContactsStatus,
  addInsCodes,
  addBrokerageInsurer,
  getDetailsAdmin,
  getBrokerageInformation
} from "../store/brokerage";
import { getBrokeragesList, loadBrokerages } from "../store/brokerages";
import { useRef, useCallback } from "react";
import { saveLogo } from "../store/logoandcolor";
import { getBrokerInformation } from "../store/broker";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Dropzone from "react-dropzone";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const InsurerAdminDefaults = (props) => {
  const dispatch = useDispatch();
  let history = useNavigate();
  const [selectedCode, setSelectedCode] = useState(null);
  const [selectedBrokerageName, setSelectedBrokerageName] = useState(
    "Search for a brokerage"
  );
  const brokerages = useSelector(getBrokeragesList);

  useEffect(() => {
    dispatch(loadBrokerages());
    if (props.brokerageCode) {
      let data = {
        brokerage_code: props.brokerageCode,
      };
      dispatch(getInsContacts(data));
      setSelectedCode(props.brokerageCode);
      dispatch(getDetailsAdmin(props.brokerageCode));
    }
  }, [dispatch]);

  useEffect(() => {
    if (
      !props.brokerageCode &&
      !selectedCode &&
      brokerages &&
      brokerages[0]?.code
    ) {
      setSelectedCode(brokerages[0]?.code);
      dispatch(getDetailsAdmin(brokerages[0]?.code));
      let data = {
        brokerage_code: brokerages[0]?.code,
      };
      dispatch(getInsContacts(data));
      setSelectedBrokerageName(brokerages[0].name);
    } else if (props.brokerageCode && brokerages) {
      for (let br of brokerages) {
        if (br.code == props.brokerageCode) {
          setSelectedBrokerageName(br.name);
          break;
        }
      }
    }
  }, [brokerages]);

  const onChangeHandle = (value) => {
    if (value[0]?.code) {
      history(
        "/quoteyadmin/insurercontacts?c=" + encodeURIComponent(value[0].code)
      );
      let data = {
        brokerage_code: value[0]?.code,
      };
      dispatch(getInsContacts(data));
      setSelectedCode(value[0]?.code);
      dispatch(getDetailsAdmin(value[0]?.code));
      setSelectedBrokerageName(value[0]?.name);
    }
  };

  return (
    <div>
      <div
        style={{
          width: "100%",
        }}
      >
        <div style={{ width: "80%", marginLeft: "10%", marginTop: "20px" }}>
          <Select
            placeholder={"Search for a brokerage"}
            color={theme.COLORS.primary_navyblue}
            searchable={true}
            onChange={(values) => onChangeHandle(values)}
            values={[]}
            options={brokerages}
            style={{
              width: "100%",
              height: "6vh",
              fontSize: "1.9vmin",
              border: "5px solid white",
              borderRadius: 15,
              fontFamily: "GibsonRegular",
            }}
            labelField={"name"}
            valueField={"code"}
            dropdownHeight={"58vh"}
          />
        </div>
      </div>
      <InsurerContacts code={selectedCode} />
    </div>
  );
};

const InsurerContacts = (props) => {
  return <InsurerContactsPane brokerageCode={props.code}></InsurerContactsPane>;
};

const InsurerContactsPane = (props) => {
  return (
    <div
      style={{
        margin: "3.5rem",
      }}
    >
      <div>
        <h5
          class="px-2"
          style={{
            fontFamily: "GibsonSemiBd",
            justifyContent: "center",
            fontSize: "1.2vw",
          }}
        >
          You can customize the contacts for the insurers in a brokerage.
        </h5>
        {/* <Logo brokerageCode={props.brokerageCode} /> */}
        <InsurerContactItems brokerageCode={props.brokerageCode} />
      </div>
    </div>
  );
};

const Logo = (props) => {
  const dispatch = useDispatch();
  let code = { brokerage_code: props.brokerageCode };
  useEffect(() => {
    getLogoCheck(code);
  }, [dispatch]);

  const [upImg, setUpImg] = useState();
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const [crop, setCrop] = useState({
    unit: "px",
    width: 225,
    height: 217,
  });
  const [completedCrop, setCompletedCrop] = useState(null);

  const [dbLogo, setDbLogo] = useState(null);
  function getLogoCheck(code) {
    let url = process.env.REACT_APP_BASICSERVICE + "/api/logoandcolor/getlogo";
    axios
      .post(
        url,
        { brokerage_code: code.brokerage_code },
        {
          headers: { "X-Auth-Token": localStorage.getItem("jwt") },
        }
      )
      .then((res) => {
        let db_img_val = "data:image/png;base64," + res.data[0].logo;
        setDbLogo(db_img_val);
      });
  }

  function fileUploadhandler(canvas, crop) {
    var b64 = canvas.toDataURL("image");
    let data = {
      brokerage_code: props.brokerageCode,
      logo: b64,
    };
    dispatch(saveLogo(data));
    toast.success("New Logo Saved");
    setDbLogo(b64);
  }

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
  }, [completedCrop]);

  const checkselectfile = (files) => {
    console.log(files[0]);
    const reader = new FileReader();
    reader.addEventListener("load", () => setUpImg(reader.result));
    reader.readAsDataURL(files[0]);
  };

  const dropzoneStyle = {
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
  };

  return (
    <div className="container" style={{ padding: "10px" }}>
      <div className="row p-3">
        <div className="col">
          <p className="font-weight-bold">Add Logo</p>
          <Button
            style={{
              display: "flex",
              width: "100px",
              height: "100%",
              maxHeight: "3vmin",
              backgroundColor: theme.COLORS.secondary_skyblue,
              borderRadius: 5,
              color: "white",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "GibsonRegular",
              fontSize: "min(0.8vw, 15px)",
              letterSpacing: 1,
              border: 0,
            }}
            disabled={!completedCrop?.width || !completedCrop?.height}
            onClick={() =>
              fileUploadhandler(previewCanvasRef.current, completedCrop)
            }
          >
            {" "}
            Upload{" "}
          </Button>
          <div>
            {/* <input type="file" accept="image/*" onChange={onSelectFile} /> */}
            <Dropzone
              onDrop={(files) => checkselectfile(files)}
              accept="image/*"
              multiple={false}
            >
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <p style={dropzoneStyle}>
                      Drag 'n' drop some files here, or click to select files
                    </p>
                  </div>
                </section>
              )}
            </Dropzone>
          </div>
          <div>
            <ReactCrop
              src={upImg}
              onImageLoaded={onLoad}
              crop={crop}
              locked={true}
              onChange={(c) => setCrop(c)}
              onComplete={(c) => setCompletedCrop(c)}
            />

            <br />
            <p>Image Preview</p>
            <div>
              <canvas
                ref={previewCanvasRef}
                // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
                style={{
                  width: Math.round(completedCrop?.width ?? 0),
                  height: Math.round(completedCrop?.height ?? 0),
                }}
              />
            </div>
          </div>
        </div>
        <div className="col">
          <p className="font-weight-bold">Current Logo</p>
          {typeof dbLogo === "undefined" ? (
            "Loading ..."
          ) : (
            <img src={dbLogo} alt="current logo" />
          )}
        </div>
      </div>
    </div>
  );
};

const InsurerContactItems = (props) => {
  let brokerage_code = props.brokerageCode;
  let data = {
    brokerage_code: props.brokerageCode,
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getInsContacts(data));
    dispatch(getUserDetails({brokerage_code}))
  }, []);
  useEffect(() => {
    dispatch(getUserDetails({brokerage_code}))
  }, [brokerage_code]);
  const onAddContactClickHandle = (value) => {
    dispatch(toggleInsContactsModal(value));
  };

  const ShowInsurerCodeHandler = (toggleValue, insurer_code) => {
    dispatch(toggleInsurerCodesModal(toggleValue));
    let data = {
      brokerage_code: brokerage_code,
      insurer_code: insurer_code,
    };
    dispatch(getInsCodes(data));
  };

  let insContacts = useSelector(getInsContactsInformation);
  let insContactsModalState = useSelector(getInsContactsStatus);
  let isUpdating = useSelector(getIsUpdating);
  let updateErrors = useSelector(getUpdateErrors);
  const [selectedInsCode, setInsCode] = useState(null);
  const [selectedInsName, setInsName] = useState(null);
  return (
    <div class="m-4" style={{ fontFamily: "GibsonRegular", fontSize: "0.8vw" }}>
      <table class="table table-sm">
        <thead>
          <tr>
            <th scope="col">Contact</th>
            <th scope="col">Contact e-mail</th>
            <th scope="col">Description or Name</th>
            <th scope="col">Default</th>
            <th scope="col"></th>
            <th scope="col" class="text-center">
              Add Insurer Code
            </th>
          </tr>
        </thead>
        <tbody>
          {insContacts ? (
            insContacts.map((item) => {
              return (
                <Fragment>
                  <tr scope="row" class="thead-light">
                    <th scope="row">{item.name}</th>
                    <th />
                    <th />
                    <th />
                    <th
                      class="text-center bg-success"
                      style={{
                        width: "40px",
                        padding: 5,
                        borderRadius: 20,
                        color: "white",
                      }}
                    >
                      {isUpdating ? (
                        <Spinner animation="border" size="sm" variant="light" />
                      ) : (
                        <AddIcon
                          onClick={() => {
                            setInsCode(
                              item.code ? item.code : item.insurer_code
                            );
                            setInsName(item.name);
                            onAddContactClickHandle(true);
                          }}
                        />
                      )}
                    </th>
                    <th class="text-center">
                      <EditIcon
                        onClick={() => {
                          setInsCode(item.code ? item.code : item.insurer_code);
                          setInsName(item.name);
                          ShowInsurerCodeHandler(true, item.insurer_code);
                        }}
                      />
                    </th>
                  </tr>
                  {item.emails ? (
                    item.emails.map((e) => {
                      return (
                        <Fragment>
                          <tr scope="row">
                            <td></td>
                            <td>{e.email}</td>
                            <td>{e.description}</td>
                            <td>
                              {e.default == "Yes" ? (
                                <CheckCircleOutlineOutlinedIcon
                                  style={{ color: "SteelBlue" }}
                                />
                              ) : (
                                <RadioButtonUncheckedOutlinedIcon
                                  style={{ color: "Gray" }}
                                  onClick={() => {
                                    let data = {
                                      insurer_code: item.code
                                        ? item.code
                                        : item.insurer_code,
                                      brokerage_code: brokerage_code,
                                      email: e.email,
                                      is_default: "Yes",
                                    };
                                    dispatch(
                                      updateInsContactDefault(data)
                                    ).then(
                                      setTimeout(() => {
                                        dispatch(getInsContacts(data));
                                        Array.isArray(updateErrors) &&
                                        !updateErrors.length
                                          ? toast.success(
                                              "Default Updated Successfully"
                                            )
                                          : toast(updateErrors);
                                      }, 1000)
                                    );
                                  }}
                                />
                              )}
                            </td>
                            <td
                              class="text-center bg-danger"
                              style={{
                                width: "40px",
                                padding: 5,
                                borderRadius: 22.5,
                                color: "white",
                              }}
                            >
                              <DeleteOutlineOutlinedIcon
                                onClick={() => {
                                  let data = {
                                    insurer_code: item.code
                                      ? item.code
                                      : item.insurer_code,
                                    email: e.email,
                                    description: e.description,
                                    is_default: e.default,
                                    brokerage_code: brokerage_code,
                                  };
                                  dispatch(deleteInsContact(data)).then(
                                    setTimeout(() => {
                                      dispatch(getInsContacts(data));
                                      Array.isArray(updateErrors) &&
                                      !updateErrors.length
                                        ? toast.success(
                                            "Contact Deleted Successfully"
                                          )
                                        : toast(updateErrors);
                                    }, 1000)
                                  );
                                }}
                              />
                            </td>
                          </tr>
                        </Fragment>
                      );
                    })
                  ) : (
                    <Fragment>
                      <tr scope="row">
                        <td></td>
                        <td>-</td>
                        <td>-</td>
                        <td>
                          <RadioButtonUncheckedOutlinedIcon
                            style={{ color: "Gray" }}
                          />
                        </td>
                        <td></td>
                      </tr>
                    </Fragment>
                  )}
                </Fragment>
              );
            })
          ) : (
            <tr />
          )}
        </tbody>
      </table>
      <Modal
        size="md"
        isOpen={insContactsModalState}
        ariaHideApp={false}
        shouldCloseOnEsc={false}
        centered
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
          },
          content: {
            height: "40vh",
            width: "50vw",
            position: "absolute",
            top: "15vh",
            left: "25vw",
            background: "#eef3f6",
            WebkitOverflowScrolling: "touch",
            border: "8px solid " + theme.COLORS.primary_navyblue,
            borderRadius: "20px",
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <AddInsurerContacts
          insName={selectedInsName}
          code={selectedInsCode}
          brokerageCode={brokerage_code}
        />
      </Modal>
      <InsurerCodesModal insName={selectedInsName} code={selectedInsCode} />
    </div>
  );
};

const AddInsurerContacts = (props) => {
  const insName = props.insName;
  const code = props.code;
  const [email, setEmail] = useState(null);
  const [description, setDescription] = useState(null);
  const [isDefault, setDefault] = useState(true);
  const dispatch = useDispatch();
  const updateErrors = useSelector(getUpdateErrors);
  const broker = useSelector(getBrokerInformation);
  const brokerage_code = props.brokerageCode;
  const onAddButtonClick = () => {
    let data = {
      insurer_name: insName,
      email: email,
      description: description,
      is_default: isDefault,
      insurer_code: code,
      brokerage_code: brokerage_code,
    };
    console.log(data);
    dispatch(addInsContact(data)).then(
      setTimeout(() => {
        dispatch(getInsContacts(data));
        Array.isArray(updateErrors) && !updateErrors.length
          ? toast.success("Added Contact Successfully")
          : toast(updateErrors);
      }, 1000)
    );
    dispatch(toggleInsContactsModal(false));
  };

  const onCancelButtonClick = (value) => {
    dispatch(toggleInsContactsModal(value));
  };

  return (
    <PerfectScrollbar>
      <div style={{ verticalAlign: "middle" }}>
        <form class="m-4">
          <h3
            class="text-center m-3"
            style={{
              fontFamily: "GibsonSemiBd",
              justifyContent: "center",
              fontSize: "1.2vw",
            }}
          >
            Enter Insurer Contact Detail for {insName}
          </h3>
          <div
            class="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblEmail" class="col-sm-4 col-form-label">
              Email
            </label>
            <div class="col-sm-8">
              <input
                class="form-control"
                id="txtEmail"
                placeholder="Enter Email"
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                defaultValue={props.email}
              />
            </div>
          </div>
          <div
            class="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblDescription" class="col-sm-4 col-form-label">
              Description
            </label>
            <div class="col-sm-8">
              <input
                class="form-control"
                id="txtDescription"
                placeholder="Enter Description"
                onChange={(event) => {
                  setDescription(event.target.value);
                }}
                defaultValue={props.description}
              />
            </div>
          </div>
          <div
            class="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblDefault" class="col-sm-4 col-form-label">
              Make Default
            </label>
            <div class="col-sm-8">
              <input
                type="checkbox"
                class="form-control"
                id="txtDefault"
                onChange={(event) => {
                  setDefault(event.target.value);
                }}
                defaultChecked={true}
              />
            </div>
          </div>
          <div class="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onAddButtonClick();
              }}
            >
              Add
            </Button>
          </div>
          <div class="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onCancelButtonClick(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </PerfectScrollbar>
  );
};

const InsurerCodesModal = (props) => {
  let insCodeModalState = useSelector(getInsCodeStatus);
  let brokerage_insurer = useSelector(getInsurerCodesSelector);
  let selectedInsName = props.insName;
  let selectedInsCode = props.code;
  let [modalHeight, setmodalHeight] = useState("40vh")
  const dispatch = useDispatch();
  if(brokerage_insurer.code && !brokerage_insurer.unique_codes){
    dispatch(toggleInsurerCodesModal(false));
  }
  useEffect(()=> {
    setmodalHeight("40vh")
  }, [selectedInsCode])
  return (
    <Modal
      size="md"
      isOpen={insCodeModalState}
      ariaHideApp={false}
      shouldCloseOnEsc={true}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: modalHeight,
          width: "50vw",
          position: "absolute",
          top: "15vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      {brokerage_insurer.unique_codes && brokerage_insurer?.quotesby != 'external' && (
        <AddInsurerCodes
          insName={selectedInsName}
          code={selectedInsCode}
          brokerage_insurer={brokerage_insurer}
        />
      )}
      {brokerage_insurer.unique_codes &&  brokerage_insurer?.quotesby == 'external'  &&   (
        <AddWawaInsurerCodes
          insName={selectedInsName}
          code={selectedInsCode}
          brokerage_insurer={brokerage_insurer}
          setmodalHeight={setmodalHeight}
        />
      )}
    </Modal>
  );
};

const AddInsurerCodes = (props) => {
  const insName = props.insName;
  const code = props.code;
  const brokerage_insurer = props.brokerage_insurer;
  const dispatch = useDispatch();
  const updateErrors = useSelector(getUpdateErrors);
  const broker = useSelector(getBrokerInformation);
  const brokerage_code = brokerage_insurer.brokerage_code;

  const [insurer_unique_code1, setInsUniqueCode1] = useState(
    brokerage_insurer.unique_codes.length > 0
      ? brokerage_insurer.unique_codes[0].code1
      : null
  );
  const [insurer_unique_code2, setInsUniqueCode2] = useState(
    brokerage_insurer.unique_codes.length > 0
      ? brokerage_insurer.unique_codes[0].code2
      : null
  );
  const [insurer_unique_code3, setInsUniqueCode3] = useState(
    brokerage_insurer.unique_codes.length > 0
      ? brokerage_insurer.unique_codes[0].code3
      : null
  );

  const onAddButtonClick = () => {
    let data = {
      insurer_name: insName,
      insurer_unique_code1: insurer_unique_code1,
      insurer_unique_code2: insurer_unique_code2,
      insurer_unique_code3: insurer_unique_code3,
      insurer_code: code,
      brokerage_code: brokerage_code,
    };
    dispatch(addInsCodes(data)).then(
      setTimeout(() => {
        Array.isArray(updateErrors) && !updateErrors.length
          ? toast.success("Unique Codes Saved Successfully")
          : toast(updateErrors);
      }, 100)
    );
    dispatch(toggleInsurerCodesModal(false));
  };

  const onCancelButtonClick = (value) => {
    dispatch(toggleInsurerCodesModal(value));
  };

  return (
    <PerfectScrollbar>
      <div style={{ verticalAlign: "middle" }}>
        <form className="m-4">
          <h3
            className="text-center m-3"
            style={{
              fontFamily: "GibsonSemiBd",
              justifyContent: "center",
              fontSize: "1.2vw",
            }}
          >
            Enter Your Brokerage Codes for {insName}
          </h3>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblBrokerCode1" className="col-sm-4 col-form-label">
              Broker Code 1
            </label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtBrokerCode1"
                placeholder="Enter Broker Code 1"
                onChange={(event) => {
                  setInsUniqueCode1(event.target.value);
                }}
                defaultValue={insurer_unique_code1}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblBrokerCode2" className="col-sm-4 col-form-label">
              Broker Code 2
            </label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtBrokerCode2"
                placeholder="Enter Broker Code 2"
                onChange={(event) => {
                  setInsUniqueCode2(event.target.value);
                }}
                defaultValue={insurer_unique_code2}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblBrokerCode3" className="col-sm-4 col-form-label">
              Broker Code 3
            </label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtBrokerCode3"
                placeholder="Enter Broker Code 3"
                onChange={(event) => {
                  setInsUniqueCode3(event.target.value);
                }}
                defaultValue={insurer_unique_code3}
              />
            </div>
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onAddButtonClick();
              }}
            >
              Add
            </Button>
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onCancelButtonClick(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </PerfectScrollbar>
  );
};

const AddWawaInsurerCodes = (props) => {
  const insName = props.insName;
  const code = props.code;
  const setmodalHeight = props.setmodalHeight;
  const brokerage_insurer = props.brokerage_insurer;
  const dispatch = useDispatch();
  const updateErrors = useSelector(getUpdateErrors);
  const broker = useSelector(getBrokerInformation);
  const brokerage_code = brokerage_insurer.brokerage_code;
  const gotBrokerageInfo = useSelector(getBrokerageInformation);
  let initalBranchObj = {};
  let intialBrokersObj = []
  let userList = useSelector(getUserInformation);
  let displayWawaList = "none";
  console.log(brokerage_insurer)
  console.log("---")
  let keys = gotBrokerageInfo.address?.map(x => x.addr_line1 + " "+ x.city + " " + x.postal_code);
  initalBranchObj = Object.fromEntries(keys?.map((x)=>[x, null]));

  for(let val in brokerage_insurer.unique_codes[1]){
    if(Object.keys(initalBranchObj).includes(val)){
      initalBranchObj[val] = brokerage_insurer.unique_codes[1][val]
    }
  }

  //show user list if defined for extneral insurer
  if(brokerage_insurer.otherinfo?.userlist){
    let userListEmails = userList.map(x => x.user.email)
    for(let userListEmail of userListEmails){
      let foundBrokerRecord = [userListEmail, userListEmail, ""]
      if(brokerage_insurer.unique_codes[2]){
        let _foundBrokerRecord = brokerage_insurer.unique_codes[2].find(arr => arr[0] == userListEmail )
        if(_foundBrokerRecord) foundBrokerRecord = _foundBrokerRecord;
      }
      intialBrokersObj.push([...foundBrokerRecord])
    }
    setmodalHeight("80vh")
  }
  
  const [inputfieldKeys, setinputfieldKeys] = useState(initalBranchObj);
  const [insurer_unique_code1, setInsUniqueCode1] = useState(brokerage_insurer.unique_codes[0]?.code1);
  const [userCodes, setUserCodes] = useState(intialBrokersObj)
  const onAddButtonClick = () => {
    let data = {
      insurer_name: insName,
      inputfieldKeys,
      insurer_unique_code1: insurer_unique_code1,
      insurer_code: code,
      brokerage_code: brokerage_code,
    };
    if(userCodes.length > 0){
      data['userCodes'] = userCodes; 
    }
    dispatch(addInsCodes(data)).then(
      setTimeout(() => {
        Array.isArray(updateErrors) && !updateErrors.length
          ? toast.success("Unique Codes Saved Successfully")
          : toast(updateErrors);
      }, 100)
    );
    dispatch(toggleInsurerCodesModal(false));
  };

  const onCancelButtonClick = (value) => {
    dispatch(toggleInsurerCodesModal(value));
  };

  return (
    <PerfectScrollbar>
      <div style={{ verticalAlign: "middle" }}>
        <form className="m-4">
          <h3
            className="text-center m-3"
            style={{
              fontFamily: "GibsonSemiBd",
              justifyContent: "center",
              fontSize: "1.2vw",
            }}
          >
            Enter Your Brokerage Codes for {insName}
          </h3>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
           { 
              keys.map((item, index) => {
                return (
                  <Fragment key={index}>
                      <label for={item} className="col-sm-4 col-form-label">
                        { item }
                      </label>
                      <div className="col-sm-8">
                        <input
                          className="form-control"
                          id={item}
                          placeholder={`Enter Broker Code for Branch ${index + 1}`} 
                          onChange={(event) => {
                           
                            setinputfieldKeys(prevState => ({
                                ...prevState,
                                [item]: event.target.value
                            }));
                          }}
                          defaultValue={inputfieldKeys[item]}
                        />
                      </div>
                  </Fragment>
                )
              })
            }
            <label for="lblBrokerCode3" className="col-sm-4 col-form-label">
              Master Code
            </label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtBrokerCode3"
                placeholder="Enter Default Code"
                onChange={(event) => {
                  setInsUniqueCode1(event.target.value);
                }}
                defaultValue={insurer_unique_code1}
              />
            </div>
          </div>
          <div className="UserList" style={{display:"block"}} >
                { userCodes?.length > 0 &&  <h4>Users</h4> }
                {userCodes.map((item, index) => {
                  return (
                    <p >
                      <div style={{ width:"2%", float:"left"}}>{index} </div>
                      <div style={{  marginLeft:"1rem", width:"34%", float: "left" }}>{item[0]} </div>
                      <input  defaultValue={item[1]}
                        onBlur={(e) => {
                          let tmp_userCodes = [...userCodes];
                          tmp_userCodes[index][1] = e.target.value
                          setUserCodes(tmp_userCodes)
                        }}
                      />
                      <input style={{ marginLeft:"1rem" }} defaultValue={item[2]}
                         onBlur={(e) => {
                          let tmp_userCodes = [...userCodes];
                          tmp_userCodes[index][2] = e.target.value
                          setUserCodes(tmp_userCodes)
                         }}
                      />
                    </p>
                  )
                })}
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onAddButtonClick();
              }}
            >
              Add
            </Button>
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onCancelButtonClick(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </PerfectScrollbar>
  );
};

export default InsurerAdminDefaults;
